import { HandleCookies } from '@/utils/handle-cookies';

const returnFirstArg = (x) => x;

export default class Service {
  constructor(api, options = {}) {
    const stilingueSessionId = HandleCookies.getCookies({ name: 'stilingue-session-id' });

    this.api = api;
    this.api.use({
      headers: {
        'Accept': 'application/json',
        'Accept-Language': 'pt-br',
        'Content-Type': 'application/json',
        'stilingue-session-id': stilingueSessionId,
      },
    });

    const { afterParser = returnFirstArg } = options;
    this.afterParser = afterParser;
    this.retriesLimit = options.retriesLimit;
  }

  async find(params, retries = 0) {
    try {
      const response = await this.api.get(params);
      return this.afterParser(response);
    } catch (err) {
      if (this.retriesLimit && retries < this.retriesLimit) {
        return this.find(params, retries + 1);
      }

      throw new Error(err);
    }
  }

  async getWithHttpErrorData(params, retries = 0, disableRetries = false) {
    try {
      const response = await this.api.get(params);
      return this.afterParser(response);
    } catch (err) {
      if ((this.retriesLimit && !disableRetries) && retries < this.retriesLimit) {
        return this.getWithHttpErrorData(params, retries + 1);
      }

      if (err.response) {
        return err.response;
      }

      throw new Error(err);
    }
  }

  update(data = {}, options = {}) {
    return this.api.post(data, options).then(this.afterParser);
  }

  modify(data = {}, options = {}) {
    return this.api.patch(data, options).then(this.afterParser);
  }

  insert(data = {}, options = {}) {
    return this.api.put(data, options).then(this.afterParser);
  }

  remove(params = {}) {
    return this.api.delete(params).then(this.afterParser);
  }
}
